import { IFaqsSection } from '../../models/FaqsInterface';

export const faqsList: IFaqsSection[] = [
  {
    id: '1',
    title: 'Planning & Bidding',
    subsections: [
      {
        id: '1',
        title: 'Pairing Package',
        faqs: [
          {
            id: '1',
            question: 'How many filters can I apply at once?',
            answer:
              'There is no limit, they can be customized as you need to help filter the Pairing Package to your needs, however, the more you use the less likely you are to see any pairing matches.'
          },
          {
            id: '2',
            question: 'How does each filter work?',
            answer:
              '<table border="1" cellpadding="0" cellspacing="0" style="width:561px;" width="561"><tbody><tr><td style="width:131px;"><p><strong>Filter Name&nbsp;</strong></p></td><td style="width:378px;"><p><strong>Behaviour&nbsp;</strong></p></td></tr><tr><td colspan="2" style="width:533px;"><p><strong>Routes&nbsp;</strong></p></td></tr><tr><td style="width:131px;"><p><strong># Days&nbsp;</strong></p></td><td style="width:378px;"><p>Displays pairings by the number of operating days.&nbsp;&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Landing In&nbsp;</strong></p></td><td style="width:378px;"><p>Displays pairings where a segment lands at the selected destination.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Layover In&nbsp;</strong></p></td><td style="width:378px;"><p>Displays pairings that have any segments with a layover at the selected destination.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Layover Duration&nbsp;</strong></p></td><td style="width:378px;"><p>Displays pairings that have any segments with a layover duration as specified. Can be used in combination with &lsquo;Layover In&rsquo; to isolate pairings at the Layover destination at a certain time.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Show deadhead flights&nbsp;</strong></p></td><td style="width:378px;"><p>By default, this option is toggled on, to allow pairings with deadheads to display. Turning it off will omit any pairings with a deadhead.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Show red-eye flights&nbsp;</strong></p></td><td style="width:378px;"><p>By default, this option is toggled on, to allow pairings with red-eye segments to display. Turning it off will omit any pairings with a red eye.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Flight #&nbsp;</strong></p></td><td style="width:378px;"><p>Search for a pairing that features a specific flight by flight number.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Sectors&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairing by the number of legs, from a departure point to an arrival point, in the pairing. i.e., YYZ to YOW returning to YYZ would be 2 sectors, as YYZ to YOW is one leg, and returning from YOW to YYZ is a second.&nbsp;</p></td></tr><tr><td colspan="2" style="width:533px;"><p><strong>Date &amp; Time&nbsp;</strong></p></td></tr><tr><td style="width:131px;"><p><strong>Date Range&nbsp;</strong></p></td><td style="width:378px;"><p>The calendar can be used to omit or isolate pairings by the selection of dates using 1 of the 3 options.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>On Duty&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by the range of hours &lsquo;On Duty&rsquo; within the pairing.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Off Duty&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by the range of hours &lsquo;Off Duty&rsquo; within the pairing.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>TAFB&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by the range of hours spent away from base, from the time you check-in for a pairing to when you checkout.&nbsp;</p></td></tr><tr><td colspan="2" style="width:533px;"><p><strong>Credit, Pay &amp; Efficiency&nbsp;</strong></p></td></tr><tr><td style="width:131px;"><p><strong>Credit&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by credit received.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Hrs/Day&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by average number of hours per day.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Expenses&nbsp;</strong></p></td><td style="width:378px;"><p>Sort and filter pairings by one of 3 options, (1) All, (2) &lsquo;Equal To&rsquo; a specific amount or (3) search for pairings with Expenses within a range.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Efficiency&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by Efficiency score, the default range is set to the lowest and highest efficiency score within the current pairing package.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Day Credit&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by setting a range for Day Credit attached to the pairing.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Night Credit&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by setting a range for Night Credit attached to the pairing.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>DH Credit&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by setting a range for Deadhead Credit attached to the pairing.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Oseas Credit&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by setting a range for Overseas Credit attached to the pairing.&nbsp;</p></td></tr><tr><td colspan="2" style="width:533px;"><p><strong>Other&nbsp;</strong></p></td></tr><tr><td style="width:131px;"><p><strong>Occurs&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by how many occurrences it has within the Block Month.&nbsp;</p></td></tr><tr><td style="width:131px;"><p><strong>Pairing Type&nbsp;</strong></p></td><td style="width:378px;"><p>Filter pairings by All, REG, CA, QOE or FO or any combination.&nbsp;</p></td></tr></tbody></table>'
          },
          {
            id: '3',
            question: 'How do I edit the columns?',
            answer:
              'You can customize your columns in the Pairing Package screen by clicking Edit Columns and clicking the checkboxes for the columns you wish to be visible and unclicking those you wish to hide. You can also save or load multiple presets; these presets are available interchangeably between the Pairing Package and the My Pairings List screen. '
          },
          {
            id: '4',
            question:
              'How do I add or remove a pairing to/from My Pairings List?',
            answer:
              'You can click the heart icon con in the Add to List column that will allow you to add the Pairing to an existing or new list in your My Pairings List screen. To remove the pairing from the list you can unclick the heart icon or delete it from the My Pairings List screen.'
          },
          {
            id: '5',
            question: 'Can the Pairings change?',
            answer:
              'The Pairing Package is subject to change until Pairing Freeze as determined by Crew Planning. If you add a pairing to your My Pairings List, you will be notified if a pairing is modified or removed.'
          },
          {
            id: '6',
            question:
              'When are Parings Posted, Pairing Freeze and Bidding Close for the Block Month?',
            answer:
              'The dates for the upcoming Planning & Bidding cycle are posted on the my ACcess landing page. Should Crew Planning make a modification to the schedule for any Block Month, changes will be indicated in red on the landing page.'
          },
          {
            id: '7',
            question: 'How do I read the Pairings labels? ',
            answer: `
                    The Pairing labels are made up of codes correlating to Base + Equipment + a Numerical Code based on pairing type, i.e., Pairing ID T4010 can be read as T-4-010 which means it is a Toronto / A220 / Regular pairing based on the provided chart. <br /><br />
                    <div>
                      <table border="1">
                        <tbody>
                          <tr>
                            <td colspan="2"><p><strong>Base</strong></p></td>
                          </tr>
                        
                        <tr>
                          <td><p><strong>M</strong></p></td>
                          <td>Montreal</td>
                        </tr>
                        <tr>
                          <td><p><strong>T</strong></p></td>
                          <td>Toronto</td>
                        </tr>
                        <tr>
                          <td><p><strong>W</strong></p></td>
                          <td>Winnipeg</td>
                        </tr>
                        <tr>
                          <td><p><strong>V</strong></p></td>
                          <td>Vancouver</td>
                        </tr>
                        </tbody>
                      </table>
                      <br /><br />
                      <table border="1">
                        <tbody>
                          <tr>
                            <th colspan="2"><p><strong>Equipment</strong></p></th>
                          </tr>
                        <tr>
                          <td><p><strong>1</strong></p></td>
                          <td>A319</td>
                        </tr>
                        <tr>
                          <td><p><strong>2</strong></p></td>
                          <td>B737</td>
                        </tr>
                        <tr>
                          <td><p><strong>3</strong></p></td>
                          <td>A320</td>
                        </tr>
                        <tr>
                          <td><p><strong>4</strong></p></td>
                          <td>A220</td>
                        </tr>
                        <tr>
                          <td><p><strong>5</strong></p></td>
                          <td>B767</td>
                        </tr>
                        <tr>
                          <td><p><strong>6</strong></p></td>
                          <td>B777</td>
                        </tr>
                        <tr>
                          <td><p><strong>7</strong></p></td>
                          <td>B787</td>
                        </tr>
                        <tr>
                          <td><p><strong>8</strong></p></td>
                          <td>A330</td>
                        </tr>             
                        </tbody>
                      </table>
                      <br /><br />
                      <table border="1">
                        <tbody>
                          <tr>
                            <td colspan="2"><p><strong>Numerical Code for Pairing Type (Narrowbody - NJA)</strong></p></td>
                          </tr>
                        <tr>
                          <td><p><strong>000-</strong></p>
                          <p><strong>599</strong></p></td>
                          <td>Regular</td>
                        </tr>
                        <tr>
                          <td>
                          <p><strong>600-</strong></p>
                          <p><strong>699</strong></p>
                          </td>
                          <td>QOE</td>
                        </tr>
                        <tr>
                          <td>
                            <p><strong>700-</strong></p>
                            <p><strong>799</strong></p>
                          </td>
                          <td>Check Pilot operating as First Officer / Check on Captain</td>
                        </tr>
                        <tr>
                          <td>
                            <p><strong>800-</strong></p>
                            <p><strong>899</strong></p>
                          </td>
                          <td>Check Pilot operating as Captain / Check on First Officer </td>
                        </tr>
                        <tr>
                          <td>
                            <p><strong>900-</strong></p>
                            <p><strong>999</strong></p>
                          </td>
                          <td>Jetz Pairings on 320 Fleet</td>
                        </tr>
                        </tbody>
                        </table>
                        <br /><br />
                      <table border="1">
                        <tbody>
                          <tr>
                            <td colspan="2"><p><strong>Numerical Code for Pairing Type (Widebody- WJA)</strong></p></td>
                          </tr>
                        <tr>
                          <td><p><strong>000-</strong></p>
                          <p><strong>299</strong></p></td>
                          <td>Regular</td>
                        </tr>
                        <tr>
                          <td>
                          <p><strong>300-</strong></p>
                          <p><strong>399</strong></p>
                          </td>
                          <td>Fly Below Rank</td>
                        </tr>
                        <tr>
                          <td>
                            <p><strong>400-</strong></p>
                            <p><strong>499</strong></p>
                          </td>
                          <td>Relief Pilot</td>
                        </tr>
                        <tr>
                          <td>
                            <p><strong>500-</strong></p>
                            <p><strong>599</strong></p>
                          </td>
                          <td>Regular</td>
                        </tr>
                        <tr>
                          <td>
                            <p><strong>600-</strong></p>
                            <p><strong>699</strong></p>
                          </td>
                          <td>QOE</td>
                        </tr>
                        <tr>
                          <td>
                            <p><strong>700-</strong></p>
                            <p><strong>799</strong></p>
                          </td>
                          <td>Check Pilot operating as First Officer / Check on Captain</td>
                        </tr>
                        <tr>
                          <td>
                            <p><strong>800-</strong></p>
                            <p><strong>899</strong></p>
                          </td>
                          <td>Check Pilot operating as Captain / Check on First Officer</td>
                        </tr>                                <tr>
                          <td>
                            <p><strong>900-</strong></p>
                            <p><strong>999</strong></p>
                          </td>
                          <td>Check Pilot operating as Captain or First Officer / Check on Relief Pilot</td>
                        </tr>                
                        </tbody>
                        </table>
                    </div>

                    `
          }
        ]
      },
      {
        id: '2',
        title: 'Pairing Dashboard',
        faqs: [
          {
            id: '1',
            question: 'How do I filter the data on the Pairing Dashboard?',
            answer:
              'The Pairing Dashboard is an interactive alternative to the Pairing Package screen that will give you a view of the breakdown of the Pairing Package. Interacting with any of the sections will affect the data shown in other sections, i.e., Clicking a specific day in ‘Number of Pairings’ will show you the breakdown of the parings on that specific day; or if you click ‘4 Days’ under ‘Pairing Duration’ it will show you credit in regard to 4-day pairings, or destinations available for 4-day pairings. Additionally, through the ‘Map’ view, you can also filter down specific pairings by ‘Arrival’ and ‘Departure’ airports.'
          },
          {
            id: '2',
            question: 'How do I see different Pairings Packages?',
            answer:
              'As with the Pairing Package screen you can change the Block Month and Position via the Search feature in the page header.'
          }
        ]
      },
      {
        id: '3',
        title: 'My Pairings List',
        faqs: [
          {
            id: '1',
            question: 'What happens if a Pairing is modified or deleted?',
            answer:
              'If you add a pairing to your My Pairings List you will be notified if a pairing is modified or removed on the landing page and within your list.'
          },
          {
            id: '2',
            question: 'Can I make a list for a different position than my own?',
            answer:
              'my ACcess currently only supports the creation of a list for your own position. You will not be able to add Pairings for other positions to your My Pairings List at this time.'
          },
          {
            id: '3',
            question: 'Where did my previous pairing list go?',
            answer:
              'Currently we only store your ‘My Pairings List’ for the prior month and the current month, so your ‘My Pairings List’ for 2 months back or longer is not retained.'
          },
          {
            id: '4',
            question: 'How do I customize the columns for My Pairings List?',
            answer:
              'You can customize your columns in the My Pairings List screen by clicking Edit Columns and clicking the checkboxes on for the columns you wish to be visible and unclicking those you wish to hide. You can also save or load multiple presets; these presets are available interchangeably between the Pairing Package and the My Pairings List screen.'
          }
        ]
      },
      {
        id: '4',
        title: 'SDO Request',
        faqs: [
          {
            id: '1',
            question: 'What are SDO’s and how do they work?',
            answer:
              '<div>The SDO Program will allow you to request and receive a maximum of 4 consecutive days off, twice per calendar year, to accommodate special events in your life. <br /><br /><ul><li>Approval for SDO requests is dependent on crewing requirements, pre-planned activities (i.e., training), and seniority </li><li>Pre-planned activities will not be changed to accommodate SDOs.</li><li>Crew Planning will establish blackout periods during the year which are identified in <em>my ACcess</em>. Pilots will NOT be able to request an SDO during a blackout period</li><li>The days are awarded twice per calendar year, and they must be used as a string of 1-4 consecutive days</li><li>Any unused days are forfeited.</li><li>Once a pilot is awarded SDO they no longer retain eligibility to bid further whether they choose to use the awarded SDO days or forfeit them</li><li>SDO days do not have any effect to the number of days off in a block month</li><li>There must be a 5-day gap between the first and second set of SDO</li><li>Once SDO are awarded the dates cannot be changed.</li></ul></div>'
          },
          {
            id: '2',
            question: 'Where can I find the SDO Request form?',
            answer:
              'The form is available within my ACcess under the "Planning & Bidding" menu and also via this link: <a href="https://myaccess.aircanada.com/sdo-landing" target="_blank">SDO Request</a>'
          },
          {
            id: '3',
            question: 'What are the future SDO Blackout dates?',
            answer: `
            <div>The blackout dates are subject to change prior to the respective SDO request period opening. <br />
              <br />
              <p>Current SDO blackout dates are:</p>
              <br />
              <ul style="list-style: none;">
              <li><ul>
                <li>16 DEC 2025 - 04 JAN 2026</li>
                <li>28 JUN - 01 JUL</li>
                <li>04 SEP - 07 SEP</li>
                <li>17 DEC - 03 JAN 2027</li>
              </ul>
              </li>
              </ul>
              <br />
              <p>Historical Blackout Dates: </p>
              <br />
              <ul><li>2025
               <ul>
                  <li>17 DEC 2024 - 05 JAN</li>
                <li>28 JUN - 01 JUL</li>
                <li>29 AUG - 01 SEP</li>
                <li>10 OCT - 13 OCT</li>
                <li>16 DEC - 04 JAN 2026</li>
                
                </ul>
              </ul>
            </div>
            `
          },
          {
            id: '4',
            question: 'How will we be notified of SDO bidding dates?',
            answer:
              'If you are currently eligible to bid for SDO, the upcoming SDO bidding dates are posted on the left side of the my ACcess landing page.'
          },
          {
            id: '5',
            question: 'I no longer want to take my SDOs, what can I do?',
            answer:
              'You can choose to ask Crew Scheduling to remove your SDOs from Netline so you may fly through the awarded dates, however, you will be forfeiting your SDO and your SDO eligibility will not be returned.'
          },
          {
            id: '6',
            question:
              'Why did a pilot with lower Seniority than me get approved for SDO while I was declined?',
            answer:
              'If you had a conflicting event at the time of the SDO awards but then it was removed after SDOs were awarded, it is possible that a less senior pilot received an SDO over you. Additionally, if a pilot bid for and was awarded the SDO as it overlapped into the Block Month (all pilots are eligible to bid 3 days into the next Block Month if they have availability on the last day of the Block Month) during the prior bidding cycle then the previously awarded SDO is not removed to make way for a more senior pilot.'
          }
        ]
      },
      {
        id: '5',
        title: 'FRL Request',
        faqs: [
          {
            id: '1',
            question: 'What is the purpose of the "FRL Request" form?',
            answer:
              'It is used to request time off under the Family Responsibility Leave provisions (referred to as Personal Leave under the Canada Labour Code).'
          },
          {
            id: '2',
            question: 'Where can I find the FRL Request form?',
            answer:
              'The form is available within my ACcess under the "Planning & Bidding" menu and also via this link: <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=34MdSZEQ-EC8-bES-aNfzwWETOO7TPBKutXUOdZVm-xUOFEzT1c4NEdVM1BJSElBN01ETDY0Rks0Qy4u" target="_blank">FRL Request</a>'
          },
          {
            id: '3',
            question: 'What is Family Responsibility Leave?',
            answer:
              'Employees are entitled to 5 personal leave days per calendar year: 3 paid and 2 unpaid. Additional details are provided on the FRL Request form and the full policy outlining eligibility and criteria for Family Responsibility Leave can be found on HR Connex.'
          }
        ]
      },
      {
        id: '6',
        title: 'Banked Deadhead',
        faqs: [
          {
            id: '1',
            question: `What is the purpose of the 'Banked Deadheads' form?`,
            answer: `The form is used to provide oversight and ensure compliance of FOM procedures for the use of business travel bookings on flights other than the originally planned deadhead.`
          },
          {
            id: '2',
            question: 'When am I required to submit this form?',
            answer:
              'Any time a business travel booking is made in place of a planned deadhead, pilots shall complete the form.'
          },
          {
            id: '3',
            question: 'Where can I find the Banked Deadheads form?',
            answer:
              'The form is available within my ACcess under the "Planning & Bidding" menu and also via this link: <a href="https://forms.office.com/pages/responsepage.aspx?id=34MdSZEQ-EC8-bES-aNfz0iPoPpVslNMrftPcONWStFUNklOV0kyMTFWN0QxM09PNkVZVEdPRE1NTC4u" target="_blank">Banked Deadheads</a>'
          },
          {
            id: '4',
            question:
              'What are some examples of unacceptable use of a Banked Deadhead?',
            answer:
              '<strong>Example 1:</strong> A pilot has a pairing with a planned deadhead, and days or weeks in advance of the pairing, books a business travel booking on the same day without having been released from the original deadhead.<br /><br />Rationale: The result is that two seats are taken out of inventory for the same pilot on the same day. This is not acceptable. Pilots are not permitted to make a replacement booking until after they have been released from the planned deadhead by Crew Scheduling.<br /><br /><strong>Example 2:</strong> A pilot has a deadhead booking to travel for training/simulator and books business travel on a different flight without asking Crew Scheduling to cancel the original deadhead booking.<br /><br />Rationale: This also results in two seats being taken out of inventory and is unacceptable. Pilots must cancel any deadhead bookings for training/simulator with the applicable Training Coordinator/Sim Scheduler/etc before booking business travel on an alternate flight.<br /><br /><strong>Example 3:</strong> A pilot uses a banked deadhead to book business travel, without MLO approval, on a flight which does not meet the criteria in FOM 6.21. Examples include bookings which exceed the distance of the originally planned deadhead, and bookings which do not fall within the geographic footprint of the originally planned deadhead.<br /><br />Rationale: For any business travel bookings which do not meet the FOM 6.21 criteria, MLO approval must be obtained.<br /><br /><strong>Example 4:</strong> A pilot uses a banked deadhead to travel while on vacation.<br /><br />Rationale: The primary intent of the banked deadhead provisions is that they be used for commuting or other work-related travel. Banked deadheads are not intended as a means to achieve ‘super seniority’ over other employees for the purposes of leisure travel.<br /><br />'
          }
        ]
      }
    ]
  },
  {
    id: '2',
    title: 'Flying Schedule',
    subsections: [
      {
        id: '1',
        title: 'My Block Month',
        faqs: [
          {
            id: '1',
            question: 'Why is my calendar showing up blank?',
            answer:
              'If you did not receive a Block for the month your Planned calendar will be blank, such as when you’re on a Leave of Absence. Should you receive any events throughout the month such as Pairings, Training events or Sick Days as the Block Month progresses, they will appear in the ‘Actual’ calendar.'
          },
          {
            id: '2',
            question:
              'My role is showing incorrectly - ‘I am a Non-Bidder (NoB), why am I showing as a Block Holder/Reserve Pilot?’ or vice versa?',
            answer:
              'It can take up to 2 Block Months for PBS to update your status to or from a Non-Bidder in the Blocks files and so in the interim we continue to display your role as passed by PBS.'
          },
          {
            id: '3',
            question:
              'I just finished my IOE, and my position hasn’t been updated, why not? ',
            answer:
              'The overview section shows your position as it was when the Blocks files were released. If there has been an update to your position mid-Block Month the changes will be reflected in the next Block Month when you are awarded a Block for your new position.'
          },
          {
            id: '4',
            question:
              'Why is there no updated credit information in the Overview or in my Pairings? ',
            answer:
              'my ACcess is a planning tool, and we cannot show any final credit values. In the Overview and in the ‘Planned’ view of each pairing you will find the initial credit but any changes to Pairing credit and overall credit can be found in IADP.'
          },
          {
            id: '5',
            question: 'How can I print my Flying Schedule?',
            answer:
              'my ACcess is a web application, and your calendar can be printed using the browser functionality to create a Print of the page.'
          },
          {
            id: '6',
            question:
              'I am missing events such as my office hours and more, why are they not displayed?',
            answer:
              'my ACcess is working towards providing pilots with a full view of their extensive calendar, but we currently only support the display of Pairings, Displaced Pairings, Reassignment Periods, Days Off (Vacation or SDO), Training Events (IOE, ART, SIM and SCHOOL, Sick Days, GDOs and RSV/RAP/RAP-Hs.'
          },
          {
            id: '7',
            question: 'How are Days On and Days Off calculated?',
            answer:
              'Days On and Days Off are calculated using a 2:00am to 1:59am (next calendar day) work window. Any days with Pairing events (including multiple events) or RSV/RAP/RAP-H that occur within that window count as a single day for "Days On". Training Events (IOE, ART, SIM, SCHOOL) are also calculated using the same window but are counted in addition to operational days. "Days Off" are calculated by looking at the number of days without any Pairings or Training activities.'
          },
          {
            id: '8',
            question: 'How are Sick Days displayed?',
            answer:
              'The Sick Days count in your overview reflects the number of Sick Days used in the current Block Month. The count is subtracted from your yearly allotment (not including Sick Days banked) and the remainder is shown in brackets.'
          }
        ]
      },
      {
        id: '2',
        title: 'Sync to Calendar',
        faqs: [
          {
            id: '1',
            question: 'How does Sync to Calendar work and how can I set it up?',
            answer:
              "The Sync to Calendar function will allow you to sync your flying schedule to a calendar on a mobile or personal device including your mobile phone, tablet or laptop. <br /><br />You can set up the feature from either the 'My Block Month' page by clicking 'Sync to Calendar' or from the Settings > Sync to Calendar screen by clicking Add Account. Account limits apply."
          },
          {
            id: '2',
            question:
              'The setup has many steps, do I have to redo it every month?',
            answer:
              'Each calendar setup only needs to be completed once unless the is an authorization failure. You do not need to complete this process monthly, each month your next upcoming Block Month’s data is pushed to synced calendars. You may delete or pause syncing to any account at any time.'
          },
          {
            id: '3',
            question: 'What type of calendars are supported?',
            answer:
              'my ACcess currently supports Google and Outlook calendars. Choosing the Outlook option allows you to set up any calendar you’ve set up in Outlook, including but not limited to Hotmail, Yahoo! and more.<br /><br />Note: Apple accounts will be supported in a future release.'
          },
          {
            id: '4',
            question: 'How many calendars can I sync my Flying Schedule to?',
            answer:
              'You can sync up to 6 calendars whether personal or shared with a family member. Each calendar is differentiated by a unique Account Nickname for a total of 6 active accounts whether they share the same email address or not.'
          },
          {
            id: '5',
            question: 'Who can I share my calendar with?',
            answer:
              'Your Flying Schedule contains sensitive information and should be shared with careful consideration. The intended purpose is to use the feature to help you plan your work and personal life and is intended for personal and family use. By accepting the terms of use you take responsibility for the data being shared and whom you are sharing it with.'
          },
          {
            id: '6',
            question:
              'Can I use the same email address for multiple calendar setups?',
            answer:
              'Yes, if you use for example your Google email address for both Apple and for Outlook, you can set it up on multiple calendars/devices as needed. You cannot, however, have two instances of Google (or Apple) with the same email address. Each setup must also have a unique Account Nickname.'
          },
          {
            id: '7',
            question:
              'How often will the calendar sync refresh to show updated events?',
            answer:
              'my ACcess will push updated event details and changes to synced calendars every 15 minutes. This includes removing cancelled events such as Pairings or Training'
          },
          {
            id: '8',
            question:
              'If I Pause syncing, will I have to reauthorize the calendar when I return it to the Active state?',
            answer:
              'No, if you Pause the account, then we simply stop syncing new data to your calendars, but your calendar is still authorized. If paused, it can be put back to an Active state at any time if you have not exceeded the 6 accounts limit.'
          },
          {
            id: '9',
            question:
              'How can I see more historical data when syncing my calendar?',
            answer:
              "Due to security constraints, my ACcess will only share one Block Month prior, the current Block Month and upcoming Block Months' data. We cannot provide any further data to a synced calendar. All Block Month data for the past year will be available via the My Block Month screen within the web app."
          },
          {
            id: '10',
            question:
              'Outlook: The account I have setup to sync to does not show my calendar information, why?',
            answer:
              'When a sync is initially setup or modified, the calendar is re-created on the end users account and must be selected on to become visible as Outlook\'s default state is "not shown" for new calendars.'
          },
          {
            id: '11',
            question:
              'Why do the notes within an event show "Code" around the text?',
            answer:
              'When viewing a synced Google Calendar in the native Apple Calendar app the notes will show all the HTML tags (Example: &lt;HTML&gt;&lt;/HTML&gt;) because the Apple Calendar does not support (at this time) decoding of the enhanced text format that Google Calendar uses. This is not within our control; However, the Outlook Calendar does not have this issue with the native Apple Calendar and can be used as an alternative. The team is working on finding an alternative solution in the meantime.'
          },
          {
            id: '12',
            question:
              'Google: Why am I seeing a "Google hasn\'t verified this app" warning during setup?',
            answer:
              'While we complete the Application Verification process with Google you will temporarily see a warning that \'my ACcess\' is not currently verified. Until we are fully verified, the workaround is to select "Advanced" and then "Go to aircanada.com (unsafe)" and you will be able to continue the Sync to Calendar setup.<br /><br />It is completely safe to do these actions as the application is completely internally controlled by Air Canada.'
          },
          {
            id: '13',
            question:
              'What is the difference between a Personal Use or Sharing with Family account?',
            answer:
              "Currently, if you are Sharing with Family and selecting Pairings there is an additional option to customize pairing names to a friendly name to appear in your family members' calendar. Choosing the right type of account is important as it helps us assess the needs and helps develop and support features that meet your needs."
          },
          {
            id: '14',
            question:
              "Can my ACcess see my calendar or my family members' whole calendar?",
            answer:
              'By consenting to use the Sync to Calendar feature, my ACcess will be granted read/write access to your calendar as set by your email provider. my ACcess will have permission to read your calendar but does not store any personal information other than the provided email address and associated tokens.'
          },
          {
            id: '15',
            question: 'How do I stop syncing my ACcess from my calendar?',
            answer:
              'There are multiple ways. Your first option is to Edit the account from the Settings screen and move the Calendar Sync status to Paused. Using this method, you can also return the account to Active status later without having to re-set up the account. <br /><br />Additionally, you can also either deauthorize it from the email client (Apple, Google or Outlook) to revoke access and stop the sync, or you can simply delete the account from the Settings screen. If you choose to delete the account, my ACcess will not retain the provided email address, associated token or any customizations.'
          },
          {
            id: '16',
            question: 'How do I edit an account?',
            answer:
              'From the Settings screen, you can modify each account including the Account Nickname, the events shared, and the status. You can also delete an account.'
          },
          {
            id: '17',
            question:
              'Outlook: I could not select my Outlook email address when setting it up, why?',
            answer:
              'If you are already logged into any Outlook account, Microsoft will pass that email address to my ACcess to set up your Sync to Calendar account with. To choose a different email address for Outlook, please either logout from Outlook on the browser or login to my ACcess using incognito mode and proceed with the Outlook setup.'
          },
          {
            id: '18',
            question: 'Why did one of my accounts stop syncing?',
            answer:
              'This could be for a couple of reasons, there could be a system error that the support team will work to resolve, or there could be actions taken outside of my ACcess affecting the account status. This could be the case if the calendar owner revoked authorization to my ACcess or the password for the associated email address was changed causing authorization to fail. Please review the alert message on the Settings screen for the suggested resolution.'
          },
          {
            id: '19',
            question:
              'What happens if I or my family member changed the name or other information associated with the personal email? Will that affect the syncing process?',
            answer:
              'If you did not change the password on the account the token should remain active, and you should not have any syncing issues. If any issues arise, please contact the support team.'
          },
          {
            id: '20',
            question:
              'What happens if one of the email addresses I am syncing to is hacked or I lose access? ',
            answer:
              'In this scenario, please visit the Settings screen and delete the account immediately and contact support to notify them.'
          }
        ]
      },
      {
        id: '3',
        title: 'Deadhead Premium',
        faqs: [
          {
            id: '1',
            question: 'What is the purpose of the “Deadhead Premium” form?',
            answer:
              'The “Deadhead Premium” form is used to submit J-seat premium claims in accordance with the Collective Agreement.<br /><br /><strong>Note:</strong> Only submit a claim once your deadhead flight has departed due to the potential for any last minute seat changes.'
          },
          {
            id: '2',
            question:
              'Do I still have to submit a Voyage Report for a J-seat premium claim?',
            answer:
              'No, as per ADMIN 23-23 bulletin a voyage report is no longer required when submitting a J-seat premium claim.'
          },
          {
            id: '3',
            question: 'Where can I find the “Deadhead Premium” form?',
            answer:
              'The form is available within my ACcess under the "Flying Schedule" menu and also via this link: <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=34MdSZEQ-EC8-bES-aNfz7hbYuwVWAlAmhwFQUUrSOpUQjQ5MVlKNk5ONjlYQkdENVhJUlRDS0Y0NS4u" target="_blank">Deadhead Premium</a>'
          },
          {
            id: '4',
            question: 'How do I claim a missing crew cycle/meal expense?',
            answer:
              'Missing crew cycle/meal expenses are to be made directly through EmpCenter. If associated with a J-seat premium claim the automated email reply will contain a direct link to EmpCenter.<br /><br /><strong>Note:</strong> Instructions on how to use Emp Center to complete a claim are located via the P-EFB App:<br /><br /><ul><li>DOC section and search “Crew Cycle Expenses & Allowance Inquiry EmpCenter - Quick Reference Guide”, or</li><li>DOC section and browse to: Flight Operations / Reference and Policy Information / Crew Pay - Administration / Crew Cycle Expenses & Allowance Inquiry EmpCenter - Quick Reference Guide</li></ul>'
          }
        ]
      }
    ]
  }
];
